.ki{gap:0.125rem;}